export { default } from "./Workflow";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-processing/Workflow/index.js